<template>
  <div id="support_input" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>お問い合わせフォーム</h2>
        </div>
        <div class="input_list">
          <ul>
            <li>
              <span>
                <label class="list_key">{{label.supportType}}</label>
                <label class="important">必須</label>
              </span>
              <select class="list_box" v-model="support.supportType">
                <option v-for="(support,index) in supportTypeList" :key="'support-' + index" v-bind:value="support">{{support.label}}</option>
              </select>
              <label v-if="errors.supportType" class="error_text">{{errors.supportType}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.title}}</label>
                <label class="important">必須</label>
              </span>
              <input type="text" class="list_box" v-model="support.title" maxlength="128"/>
              <label v-if="errors.title" class="error_text">{{errors.title}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.supportBody}}</label>
                <label class="important">必須</label>
              </span>
              <textarea class="list_box" v-model="support.supportBody" cols="100" rows="5" maxlength="256"/>
              <label v-if="errors.supportBody" class="error_text">{{errors.supportBody}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.userName}}</label>
                <label class="important">必須</label>
              </span>
              <div class="list_box">
                <input type="text" class="list_box" v-model="support.userLastName" placeholder="家具" maxlength="32"/>
                <input type="text" class="list_box" v-model="support.userFirstName" placeholder="太郎" maxlength="32"/>
              </div>
              <label v-if="errors.userName" class="error_text">{{errors.userName}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.userNameKana}}</label>
                <label class="important">必須</label>
              </span>
              <div class="list_box">
                <input type="text" class="list_box" v-model="support.userLastNameKana" placeholder="カグ" maxlength="32"/>
                <input type="text" class="list_box" v-model="support.userFirstNameKana" placeholder="タロウ" maxlength="32"/>
              </div>
              <label v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</label>
            </li>
            <li>
              <span>
                <label class="list_key">{{label.email}}</label>
                <label class="important">必須</label>
              </span>
              <input type="text" class="list_box" v-model="support.email" maxlength="128" placeholder="****@domans.co.jp"/>
              <label v-if="errors.email" class="error_text">{{errors.email}}</label>
            </li>
          </ul>
        </div>
        <div id="regist_btn">
          <button type="submit" class="main_btn cancel_btn" @click="cancel()">戻る</button>
          <button type="submit" class="main_btn" @click="cofirm()">お問合せする</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../utils/App'
import * as Check from '../../utils/Check'
import {DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import {SUPPORT_TYPE} from '../constants/TypeEc'

export default {
  name: 'SupportInput',
  components: {
    'dd-header': Header
  },
  data () {
    return {
      support: {
        supportType: {},
        title: '',
        supportBody: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        email: ''
      },
      errors: {},
      label: {
        supportType: '質問カテゴリ',
        title: '件名',
        supportBody: '本文',
        userName: 'ご氏名',
        userNameKana: 'ご氏名（カナ）',
        email: 'ご連絡先メールアドレス'
      }
    }
  },
  computed: {
    supportTypeList: function () {
      return Object.keys(SUPPORT_TYPE)
        .map(e => SUPPORT_TYPE[e])
    }
  },
  methods: {
    cofirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return
      }

      App.setLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA, this.support)

      this.$router.push({
        name: 'SupportConfirm',
        params: {
          supportData: this.support
        }
      })
    },
    cancel: function () {
      this.$router.go(-1)
    },
    validateRequire: function () {
      if (!this.support.supportType) this.errors['supportType'] = this.label.supportType + 'は必須項目です。'
      if (!this.support.title) this.errors['title'] = this.label.title + 'は必須項目です。'
      if (!this.support.supportBody) this.errors['supportBody'] = this.label.supportBody + 'は必須項目です。'
      if (!this.support.userLastName || !this.support.userFirstName) this.errors['userName'] = this.label.userName + 'は必須項目です。'
      if (!this.support.userLastNameKana || !this.support.userFirstNameKana) this.errors['userNameKana'] = this.label.userNameKana + 'は必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isKana(this.support.userLastNameKana) || !Check.isKana(this.support.userFirstNameKana)) {
        this.errors['userNameKana'] = this.label.userNameKana + 'はカタカナで入力してください。'
      }
      if (!Check.isMail(this.support.email)) this.errors['email'] = 'メールアドレスの形式ではありません。'
    },
    fetchData: function () {
      let lform = App.getLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
      if (lform) {
        this.support = lform
      }
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/SupportInput.vue